import { render } from "./my_orders.html?vue&type=template&id=6a5e69ac&external"
import script from "./my_orders.js?vue&type=script&lang=js&external"
export * from "./my_orders.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__